export const adminContent = {
  ar: {
    login: {
      title: "لوحة التحكم",
      sub: "تسجيل دخول المشرف — YacoubCreates",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      submit: "دخول",
      submitting: "جارٍ الدخول…",
      errors: {
        invalid: "بيانات الدخول غير صحيحة.",
        locked: "محاولات كثيرة — حاول بعد 15 دقيقة.",
        generic: "حدث خطأ، حاول مجدداً.",
        connection: "تعذر الاتصال بالخادم. تأكد من تشغيله ثم حاول مجدداً.",
      },
    },
    dashboard: {
      title: "لوحة الموارد",
      subtitle: "إدارة الأدوات والموارد الظاهرة في الموقع",
      newResource: "مورد جديد",
      viewSite: "عرض الموقع",
      logout: "تسجيل الخروج",
      loading: "جارٍ التحميل…",
      empty: "لا توجد موارد بعد — أنشئ أول مورد.",
    },
    status: {
      published: "منشور",
      draft: "مسودة",
      featured: "مميز",
      archived: "مؤرشف",
    },
    actions: {
      edit: "تعديل",
      delete: "حذف",
      archive: "أرشفة",
      unarchive: "إلغاء الأرشفة",
      publish: "إظهار",
      unpublish: "إخفاء",
      feature: "تمييز",
      unfeature: "إلغاء التمييز",
      open: "فتح الرابط",
      confirmDelete: "حذف هذا المورد نهائياً؟",
    },
    form: {
      createTitle: "مورد جديد",
      editTitle: "تعديل المورد",
      titleAr: "العنوان (عربي)",
      titleEn: "العنوان (إنجليزي)",
      descAr: "الوصف (عربي)",
      descEn: "الوصف (إنجليزي)",
      thumbnailUrl: "رابط الصورة المصغرة",
      thumbnailUpload: "أو رفع صورة",
      externalUrl: "الرابط الخارجي للمورد",
      platform: "المنصة",
      type: "النوع",
      access: "نوع الوصول",
      published: "منشور",
      featured: "مميز",
      save: "حفظ",
      saving: "جارٍ الحفظ…",
      cancel: "إلغاء",
    },
    platforms: {
      google_drive: "Google Drive",
      notion: "Notion",
      github: "GitHub",
      gumroad: "Gumroad",
      website: "موقع ويب",
      other: "أخرى",
    },
    types: {
      tool: "أداة",
      template: "قالب",
      prompt: "برومبت",
      guide: "دليل",
      file: "ملف",
      automation: "أتمتة",
      saas_resource: "مورد SaaS",
    },
    access: {
      free: "مجاني",
      paid: "مدفوع",
      requires_signup: "يتطلب تسجيل",
    },
    toasts: {
      saved: "تم حفظ المورد.",
      updated: "تم تحديث المورد.",
      deleted: "تم حذف المورد.",
      tooLarge: "الصورة كبيرة — الحد الأقصى 8MB.",
    },
  },
  en: {
    login: {
      title: "Admin Dashboard",
      sub: "Admin sign in — YacoubCreates",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      submitting: "Signing in…",
      errors: {
        invalid: "Invalid credentials.",
        locked: "Too many attempts — try again in 15 minutes.",
        generic: "Something went wrong, try again.",
        connection: "Cannot reach the server. Make sure it is running, then try again.",
      },
    },
    dashboard: {
      title: "Resources Dashboard",
      subtitle: "Manage the tools and resources shown on the site",
      newResource: "New resource",
      viewSite: "View site",
      logout: "Log out",
      loading: "Loading…",
      empty: "No resources yet — create your first one.",
    },
    status: {
      published: "Published",
      draft: "Draft",
      featured: "Featured",
      archived: "Archived",
    },
    actions: {
      edit: "Edit",
      delete: "Delete",
      archive: "Archive",
      unarchive: "Unarchive",
      publish: "Show",
      unpublish: "Hide",
      feature: "Feature",
      unfeature: "Unfeature",
      open: "Open link",
      confirmDelete: "Permanently delete this resource?",
    },
    form: {
      createTitle: "New resource",
      editTitle: "Edit resource",
      titleAr: "Title (Arabic)",
      titleEn: "Title (English)",
      descAr: "Description (Arabic)",
      descEn: "Description (English)",
      thumbnailUrl: "Thumbnail URL",
      thumbnailUpload: "Or upload an image",
      externalUrl: "External resource URL",
      platform: "Platform",
      type: "Type",
      access: "Access type",
      published: "Published",
      featured: "Featured",
      save: "Save",
      saving: "Saving…",
      cancel: "Cancel",
    },
    platforms: {
      google_drive: "Google Drive",
      notion: "Notion",
      github: "GitHub",
      gumroad: "Gumroad",
      website: "Website",
      other: "Other",
    },
    types: {
      tool: "Tool",
      template: "Template",
      prompt: "Prompt",
      guide: "Guide",
      file: "File",
      automation: "Automation",
      saas_resource: "SaaS Resource",
    },
    access: {
      free: "Free",
      paid: "Paid",
      requires_signup: "Requires signup",
    },
    toasts: {
      saved: "Resource saved.",
      updated: "Resource updated.",
      deleted: "Resource deleted.",
      tooLarge: "Image too large — 8MB max.",
    },
  },
  fr: {
    login: {
      title: "Tableau de bord",
      sub: "Connexion administrateur — YacoubCreates",
      email: "Email",
      password: "Mot de passe",
      submit: "Se connecter",
      submitting: "Connexion…",
      errors: {
        invalid: "Identifiants incorrects.",
        locked: "Trop de tentatives — réessayez dans 15 minutes.",
        generic: "Une erreur est survenue, réessayez.",
        connection: "Connexion au serveur impossible. Vérifiez qu’il fonctionne, puis réessayez.",
      },
    },
    dashboard: {
      title: "Tableau des ressources",
      subtitle: "Gérez les outils et ressources affichés sur le site",
      newResource: "Nouvelle ressource",
      viewSite: "Voir le site",
      logout: "Se déconnecter",
      loading: "Chargement…",
      empty: "Aucune ressource pour le moment — créez la première.",
    },
    status: {
      published: "Publié",
      draft: "Brouillon",
      featured: "En avant",
      archived: "Archivé",
    },
    actions: {
      edit: "Modifier",
      delete: "Supprimer",
      archive: "Archiver",
      unarchive: "Désarchiver",
      publish: "Afficher",
      unpublish: "Masquer",
      feature: "Mettre en avant",
      unfeature: "Retirer la mise en avant",
      open: "Ouvrir le lien",
      confirmDelete: "Supprimer définitivement cette ressource ?",
    },
    form: {
      createTitle: "Nouvelle ressource",
      editTitle: "Modifier la ressource",
      titleAr: "Titre (arabe)",
      titleEn: "Titre (anglais)",
      descAr: "Description (arabe)",
      descEn: "Description (anglais)",
      thumbnailUrl: "URL de la miniature",
      thumbnailUpload: "Ou téléverser une image",
      externalUrl: "URL externe de la ressource",
      platform: "Plateforme",
      type: "Type",
      access: "Type d'accès",
      published: "Publié",
      featured: "En avant",
      save: "Enregistrer",
      saving: "Enregistrement…",
      cancel: "Annuler",
    },
    platforms: {
      google_drive: "Google Drive",
      notion: "Notion",
      github: "GitHub",
      gumroad: "Gumroad",
      website: "Site web",
      other: "Autre",
    },
    types: {
      tool: "Outil",
      template: "Template",
      prompt: "Prompt",
      guide: "Guide",
      file: "Fichier",
      automation: "Automatisation",
      saas_resource: "Ressource SaaS",
    },
    access: {
      free: "Gratuit",
      paid: "Payant",
      requires_signup: "Inscription requise",
    },
    toasts: {
      saved: "Ressource enregistrée.",
      updated: "Ressource mise à jour.",
      deleted: "Ressource supprimée.",
      tooLarge: "Image trop lourde — 8 Mo max.",
    },
  },
};
